import axios from "axios";

/*
 * Who receives CMMS work order mail: /api/notification-preferences.
 *
 * No companyKey anywhere, which is the one place this departs from every other CMMS fetcher — and
 * it is not because there is no tenancy here. The server scopes both calls to the company on the
 * signed-in user's own row. Every other fetcher on this page reads companyKey out of localStorage,
 * which is the client choosing its own tenant; sending one here would be handing the server a
 * boundary to trust rather than one to enforce. The preference itself stays per-person, because a
 * person has one inbox.
 *
 * The listing is a join, not a read of the preference table: most people have no row at all and
 * still have to appear in the grid so that one of them can be switched off. emailEnabled arrives
 * already resolved against the "no row means enabled" default, so nothing here has to know that
 * rule — and nothing here should reimplement it.
 *
 * Shaped like cmmsStorageLocation.jsx, throwResponseData included, so formatCmmsError can print
 * the server's sentence rather than "Request failed with status code 400".
 *
 * Nothing here sends a user id for "who changed this". The server takes that from the token.
 */
const baseUrl = "/api/notification-preferences";

const throwResponseData = (error) => {
  throw error.response?.data ?? error;
};

/*
 * Defaults to the technician tier, because that is who the department fan-out mails. Pass false to
 * widen: a work order can be dispatched to somebody personally whatever their role, and that person
 * would otherwise be unreachable from this screen.
 */
export const getNotificationPreferences = async (technicianOnly = true) => {
  try {
    const response = await axios.get(baseUrl, { params: { technicianOnly } });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

/*
 * Answers 204, so response.data is empty — returned anyway to keep the two shaped alike.
 *
 * Turning mail back on sets the flag rather than clearing the row: "never touched" and "switched
 * on again" are different things, and only one of them says who switched it off first.
 */
export const setNotificationPreference = async (userId, emailEnabled) => {
  try {
    const response = await axios.put(`${baseUrl}/${userId}`, { emailEnabled });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};
